import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { IGenericFormLoader } from '../../interfaces/form-label';

@Component({
  selector: 'cargoes-more-info-request',
  templateUrl: './more-info-request.component.html',
  styles: [],
})
export class MoreInfoRequestComponent implements OnInit, IGenericFormLoader {
  approvalStatusList: any = [];
  @Input() defaultFormData: any;
  @Output() submitedFormData = new EventEmitter<any>();
  moreInfoForm!: FormGroup;
  formData = { "variables": {
    "action":{},
    "comments":{}
  } };
  load = false;
  constructor(private formBuilder: FormBuilder) { }

  ngOnInit() {

    if(typeof this.defaultFormData === 'object' ){
      this.onLoad(this.defaultFormData);
      this.load = true;
    }
  }

  onLoad(data: any) {
    this.moreInfoForm = this.formBuilder.group({
      approvalStatus: ['', [Validators.required]],
      comments: [''],
    });
   //console.log('checking rdm',data.rdmData)
    let keys = Object.keys(data.rdmData);
    keys.forEach((key) => {
      if (key.indexOf('approval') >= 0) {
        this.approvalStatusList = data.rdmData[key];
      }
    });
  }

  onSubmit() {

    for (const i in this.moreInfoForm.controls) {
      this.moreInfoForm.controls[i].markAsDirty();
      this.moreInfoForm.controls[i].updateValueAndValidity();
    }

    if (this.moreInfoForm.value.approvalStatus.length > 0) {
      this.formData.variables['action'] = { "value": this.moreInfoForm.value.approvalStatus };
    }
    if ((this.moreInfoForm.value.comments.length > 0)) {

      this.formData.variables['comments'] = { "value": this.moreInfoForm.value.comments };
    }

    if (this.moreInfoForm.valid) {
      this.submitedFormData.emit(this.formData);
    }

  }

}
